export function isSmartFormForcedTokenHelper(tokens) {
  return !!(
    tokens?.smartForm?.length &&
    tokens?.smartForm.find(t => t.token) &&
    tokens?.forced
  )
}
